module.exports = __webpack_public_path__ + "static/media/red_car.af76b069.png";